import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-parallex-bg',
  templateUrl: './breadcrumb-parallex-bg.component.html',
  styleUrls: ['./breadcrumb-parallex-bg.component.scss']
})
export class BreadcrumbParallexBgComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
